import { useApi, createApiHook } from "../utils/apiUtils";

const useUpdateTimeParams = () => {
  const { apiPatch } = useApi();
  const useApiState = createApiHook(null);
  const { error, startLoading, setResponse } = useApiState();

  const updateTimeParams = async ({ appId, time_warning_minutes, time_close_warning_minutes, time_auto_close_minutes, timed }) => {
    startLoading();

    const body = {
      time_warning_minutes,
      time_close_warning_minutes,
      time_auto_close_minutes,
    };

    if (typeof timed !== "undefined") {
      body.timed = timed;
    }

    const response = await apiPatch(`/aplicaciones/${appId}/update_time_params`, "Error al actualizar los parámetros de tiempo", body);

    setResponse(response);
    return response;
  };

  return { updateTimeParams, error };
};

export default useUpdateTimeParams;
